import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchDataCommon } from '../../services/api';

export const getDataCommon = createAsyncThunk(
  'dataCommon/getDataCommon',
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchDataCommon();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const dataCommonSlice = createSlice({
  name: 'dataCommon',
  initialState: {
    sellerAccounts: [],
    categories: [],
    printers: [],
    users: [],
    noteTemplates: [],
    autoMessages: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDataCommon.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDataCommon.fulfilled, (state, action) => {
        state.loading = false;
        state.sellerAccounts = action.payload.sellerAccounts || [];
        state.categories = action.payload.categories || [];
        state.printers = action.payload.printers || [];
        state.users = action.payload.users || [];
        state.noteTemplates = action.payload.noteTemplates || [];
        state.autoMessages = action.payload.autoMessages || [];
      })
      .addCase(getDataCommon.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Lỗi lấy dữ liệu chung';
      });
  },
});

export default dataCommonSlice.reducer;
